import { render } from "./KilimoAI.vue?vue&type=template&id=03870c1d&scoped=true"
import script from "./KilimoAI.vue?vue&type=script&lang=js"
export * from "./KilimoAI.vue?vue&type=script&lang=js"

import "./KilimoAI.vue?vue&type=style&index=0&id=03870c1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03870c1d"]])

export default __exports__